import { createSlice } from '@reduxjs/toolkit';
import { requestStatusConstants } from '../../../Integration/integration-util';
import { initialState } from './AddMeasurement.constant';

const addMeasurementSlice = createSlice({
  name: 'addMeasurement',
  initialState,
  reducers: {
    addMeasurementAction(state, action) {
      state.UPLOAD_SCREEN.status = requestStatusConstants.PROGRESS;
      state.UPLOAD_SCREEN.error = null;
      state.UPLOAD_SCREEN.pixelId = null;
    },
    addMeasurementSuccessAction(state, action) {
      state.UPLOAD_SCREEN.status = requestStatusConstants.SUCCESS;
      state.UPLOAD_SCREEN.data = action.payload.id;
      state.UPLOAD_SCREEN.error = null;
    },
    addMeasurementFailedAction(state, action) {
      state.UPLOAD_SCREEN.status = requestStatusConstants.FAILED;
      state.UPLOAD_SCREEN.error = action.payload?.response?.data?.message;
    },
    resetAddMeasurementAction(state) {
      state.UPLOAD_SCREEN = initialState.UPLOAD_SCREEN;
    },
    validateScreenListAction(state) {
      state.VALIDATE_SCREEN.status = requestStatusConstants.PROGRESS;
      state.VALIDATE_SCREEN.error = null;
    },
    validateScreenListSuccessAction(state, action) {
      state.VALIDATE_SCREEN.status = requestStatusConstants.SUCCESS;
    },
    validateScreenListFailedAction(state, action) {
      state.VALIDATE_SCREEN.status = requestStatusConstants.FAILED;
      state.VALIDATE_SCREEN.error = action.payload?.response?.data?.id;
    },
    resetValidateScreenListAction(state) {
      state.VALIDATE_SCREEN = {
        ...initialState.VALIDATE_SCREEN,
        status:
          state.VALIDATE_SCREEN.status !== requestStatusConstants.FAILED
            ? requestStatusConstants.INITIAL
            : state.VALIDATE_SCREEN.status,
      };
    },
    setPixelIdAction(state, action) {
      state.UPLOAD_SCREEN.pixelId = action.payload;
    },
    setSelectedFileCountAction(state, action) {
      state.selectedFileCount = action.payload;
    },
    setIsEditAction(state, action) {
      state.isEdit = action.payload.isEdit;
    },
    getScreenListAction(state) {
      state.GET_SCREEN_LIST.status = requestStatusConstants.PROGRESS;
      state.GET_SCREEN_LIST.error = null;
      state.GET_SCREEN_LIST.data = initialState.GET_SCREEN_LIST.data;
    },
    getScreenListSuccessAction(state, action) {
      state.GET_SCREEN_LIST.status = requestStatusConstants.SUCCESS;
      state.GET_SCREEN_LIST.data = action.payload.id;
    },
    getScreenListFailedAction(state, action) {
      state.GET_SCREEN_LIST.status = requestStatusConstants.FAILED;
      state.GET_SCREEN_LIST.error = action.payload?.response?.data?.id;
    },
    getMissingScreenListAction(state) {
      state.GET_MISSING_SCREEN_LIST.status = requestStatusConstants.PROGRESS;
      state.GET_MISSING_SCREEN_LIST.error = null;
      state.GET_MISSING_SCREEN_LIST.data =
        initialState.GET_MISSING_SCREEN_LIST.data;
    },
    getMissingScreenListSuccessAction(state, action) {
      state.GET_MISSING_SCREEN_LIST.status = requestStatusConstants.SUCCESS;
      state.GET_MISSING_SCREEN_LIST.data = action.payload.id;
    },
    getMissingScreenListFailedAction(state, action) {
      state.GET_MISSING_SCREEN_LIST.status = requestStatusConstants.FAILED;
      state.GET_MISSING_SCREEN_LIST.error = action.payload?.response?.data?.id;
    },
    resetGetMissingScreenListAction(state) {
      state.GET_MISSING_SCREEN_LIST.status = requestStatusConstants.CONTINUE;
    },
    downloadMissingScreenListAction(state) {
      state.DOWNLOAD_MISSING_SCREEN_LIST.status =
        requestStatusConstants.PROGRESS;
      state.DOWNLOAD_MISSING_SCREEN_LIST.error = null;
      state.DOWNLOAD_MISSING_SCREEN_LIST.data =
        initialState.DOWNLOAD_MISSING_SCREEN_LIST.data;
    },
    downloadMissingScreenListSuccessAction(state, action) {
      state.DOWNLOAD_MISSING_SCREEN_LIST.status =
        requestStatusConstants.SUCCESS;
      state.DOWNLOAD_MISSING_SCREEN_LIST.data = action.payload.id;
    },
    downloadMissingScreenListFailedAction(state, action) {
      state.DOWNLOAD_MISSING_SCREEN_LIST.status = requestStatusConstants.FAILED;
      state.DOWNLOAD_MISSING_SCREEN_LIST.error =
        action.payload?.response?.data?.id;
    },
  },
});

export const {
  addMeasurementAction,
  addMeasurementSuccessAction,
  addMeasurementFailedAction,
  resetAddMeasurementAction,
  validateScreenListAction,
  validateScreenListSuccessAction,
  validateScreenListFailedAction,
  resetValidateScreenListAction,
  setPixelIdAction,
  setSelectedFileCountAction,
  setIsEditAction,
  getScreenListAction,
  getScreenListSuccessAction,
  getScreenListFailedAction,
  getMissingScreenListAction,
  getMissingScreenListSuccessAction,
  getMissingScreenListFailedAction,
  downloadMissingScreenListAction,
  downloadMissingScreenListSuccessAction,
  downloadMissingScreenListFailedAction,
  resetGetMissingScreenListAction,
} = addMeasurementSlice.actions;

export default addMeasurementSlice.reducer;
